import { createAction } from "@reduxjs/toolkit";
import { LaunchPayload } from "./types";
export const launchPlaynow = createAction<LaunchPayload>("launchPlaynow");
